import { handleActions, combineActions } from 'redux-actions';
import * as actions from '../actions';

const defaultState = {
  current: {},
  photos: [],
  take: 50,
  page: 1,
  count: 0,
  query: { uploadDatetime: 'Any', altTag: '', missingCredits: 'All', onlyPhoto: 'All', addedById: null },
  userOptions: [],
};

const reducer = handleActions(
  {
    [combineActions(actions.photos.getPhotosSuccess, actions.photos.searchPhotosSuccess)]: (
      state,
      { payload: { photos } }
    ) => {
      return { ...state, photos };
    },
    [actions.photos.getPhotos]: (state, { payload: { page } }) => {
      return { ...state, page };
    },
    [actions.photos.setPhotoCount]: (state, { payload: { count } }) => {
      return { ...state, count };
    },
    [actions.photos.setPhotoPage]: (state, { payload: { page } }) => {
      return { ...state, page };
    },
    [actions.photos.setPhotoQuery]: (state, { payload: { query } }) => {
      return { ...state, query };
    },
    [actions.photos.getUsersSuccess]: (state, { payload: { users } }) => {
      return {
        ...state,
        userOptions: users.map(user => {
          return {
            key: user.id,
            text: user.email,
            value: user.id,
          };
        }),
      };
    },
    [combineActions(actions.photos.getPhotoByIdSuccess)]: (state, { payload: { current } }) => {
      return { ...state, current };
    },
  },
  defaultState
);

export default reducer;
